/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
    NavLink,
    useLocation,
    useNavigate,
    useSearchParams,
    useParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import qs from "qs";
import SearchIcon from "@mui/icons-material/Search";
import axios from "../../CustomAxios";
import { Delete } from "@mui/icons-material";
import {
    Alert,
    Breadcrumbs as MuiBreadcrumbs,
    Button,
    Divider as MuiDivider,
    Grid,
    IconButton,
    Link,
    Paper as MuiPaper,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Toolbar,
    Tooltip,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    CircularProgress,
    Box,
} from "@mui/material";
import { Add as AddIcon, Download } from "@mui/icons-material";
import RestoreIcon from '@mui/icons-material/Restore';
import { spacing } from "@mui/system";
import { withStyles } from "@mui/styles";
import Loading from "../components/Loading";
import { CSVLink } from "react-csv";
import moment from "moment";


const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);
const Spacer = styled.div` flex: 1 1 100%; `;
const ToolbarTitle = styled.div` min-width: 150px; `;

const headCells = [
    { id: "serial_no", alignment: "left", label: "Serial No" },
    { id: "name", alignment: "left", label: "Name" },
    { id: "description", alignment: "left", label: "Description" },
    { id: "audit_logs", alignment: "left", label: "View Logs" },
];

const EnhancedTableHead = ({ viewPermission, editPermission, auths }) => {
    const [head, setHeads] = useState(headCells);
    const authData = JSON.parse(localStorage.getItem("AuthData"));

    useEffect(() => {
        let newHead = [...headCells];
        if (editPermission) newHead.push({ id: "edit", alignment: "center", label: "Edit" });
        if (auths?.user?.role?.permissions?.includes("delete_ap_machine") || authData?.type === "super_admin") newHead.push({ id: "action", alignment: "center", label: "Action" });
        setHeads(newHead);
    }, [viewPermission, editPermission]);

    return (
        <TableHead>
            <TableRow>
                {head.map((headCell) => (
                    <TableCell key={headCell.id} align={headCell.alignment}>
                        {headCell.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

const EnhancedTableToolbar = ({ search, setSearch, csvPermission, rows, onCreateMachineOpen, auths }) => {
    const navigate = useNavigate();
    const timestamp = moment().format("DD-MM-YY HH:mm");
    const authData = JSON.parse(localStorage.getItem("AuthData"));

    return (
        <form onSubmit={(e) => e.preventDefault()}>
            <Toolbar>
                <ToolbarTitle>
                    <Typography variant="h6">Machines</Typography>
                </ToolbarTitle>
                <Spacer />

                {(auths?.user?.role?.permissions?.includes("create_ap_machine") || authData?.type === "super_admin") && <Tooltip title="Add Machine">
                    <IconButton onClick={onCreateMachineOpen} sx={{ ml: 2 }}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>}
            </Toolbar>
        </form>
    );
};

const EnhancedTable = ({
    machineList,
    page,
    setPage,
    limit,
    setLimit,
    total_results,
    viewPermission,
    editPermission,
    csvPermission,
    onCreateMachineOpen,
    onEditMachineOpen,
    auths,
    onDeleteMachineOpen,
    onRestoreMachineOpen,
    metadata,
    loading,
    openViewAuditLogsModal,
    setOpenViewAuditLogsModal,
    auditLogs,
    setAuditLogs
}) => {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [rows, setRows] = useState([]);
    const authData = JSON.parse(localStorage.getItem("AuthData"));

    useEffect(() => {
        const newRows = machineList?.map(machine => ({
            id: machine._id,
            serial_no: machine.serial_no,
            name: machine.name,
            description: machine.description,
            ap_company: machine.ap_company,
            is_deleted: machine.is_deleted || false,
            audit_logs: machine?.audit_logs || null,
        }));
        setRows(newRows);
    }, [machineList]);

    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setLimit(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Paper>
            <EnhancedTableToolbar
                search={search}
                setSearch={setSearch}
                csvPermission={csvPermission}
                rows={rows}
                onCreateMachineOpen={onCreateMachineOpen}
                auths={auths}
            />

            {loading ?
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </Box> :
                <TableContainer>
                    <Table size="small">
                        <EnhancedTableHead
                            viewPermission={viewPermission}
                            editPermission={editPermission}
                            auths={auths}
                        />
                        <TableBody>
                            {rows?.map((row) => (
                                <TableRow key={row.id} style={{
                                    backgroundColor: row?.is_deleted ? "#eeaa9c" : "#fff",
                                }}>
                                    <TableCell align="left">{row.serial_no}</TableCell>
                                    <TableCell align="left">{row.name}</TableCell>
                                    <TableCell align="left">{row.description}</TableCell>
                                    {row?.audit_logs?.length ? (
                                        <TableCell align="left">
                                            <VisibilityIcon

                                                onClick={() => {
                                                    setOpenViewAuditLogsModal(true)
                                                    setAuditLogs(row?.audit_logs)
                                                }}
                                                sx={{ color: "green", cursor: "pointer" }}
                                            >
                                                View Logs
                                            </VisibilityIcon>
                                        </TableCell>
                                    ) : (
                                        <TableCell align="left">
                                            <VisibilityIcon
                                                disabled={true}
                                                sx={{ color: "grey", opacity: 0.4 }}
                                            >
                                                View Logs
                                            </VisibilityIcon>
                                        </TableCell>
                                    )}

                                    {editPermission && (
                                        <TableCell align="center">
                                            <EditIcon
                                                onClick={() => onEditMachineOpen(row)}
                                                style={{ cursor: "pointer", color: "blue" }}
                                            />
                                        </TableCell>
                                    )}

                                    {(auths?.user?.role?.permissions?.includes("delete_ap_machine") || authData?.type === "super_admin") && !row?.is_deleted && (
                                        <TableCell align="center">
                                            <Tooltip title="Delete Machine">
                                                <Delete
                                                    onClick={() => onDeleteMachineOpen(row)}
                                                    style={{ cursor: "pointer", color: "red" }}
                                                />
                                            </Tooltip>
                                        </TableCell>
                                    )}

                                    {(auths?.user?.role?.permissions?.includes("delete_ap_machine") || authData?.type === "super_admin") && row?.is_deleted && (
                                        <TableCell align="center">
                                            <Tooltip title="Restore Machine">
                                                <RestoreIcon
                                                    onClick={() => onRestoreMachineOpen(row)}
                                                    style={{ cursor: "pointer", color: "green" }}
                                                />
                                            </Tooltip>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>}

            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={metadata?.total_results}
                rowsPerPage={limit}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};

const CreateMachineModal = ({ open, onClose, onSubmit, company_id }) => {
    const [formData, setFormData] = useState({
        name: "",
        serial_no: "",
        description: "",
        ap_company: company_id,
    });
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        onSubmit(formData)
            .then(() => {
                onClose();
                setFormData({ name: "", serial_no: "", description: "", ap_company: company_id });
            })
            .finally(() => setLoading(false));
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Create New Machine</DialogTitle>
            <DialogContent>
                <DialogContentText mb={3}>
                    Please fill in the details for the new machine.
                </DialogContentText>

                <form onSubmit={handleSubmit}>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Name"
                        fullWidth
                        required
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                    <TextField
                        margin="dense"
                        label="Serial Number"
                        fullWidth
                        required
                        value={formData.serial_no}
                        onChange={(e) => setFormData({ ...formData, serial_no: e.target.value })}
                    />
                    <TextField
                        margin="dense"
                        label="Description"
                        fullWidth
                        multiline
                        rows={2}
                        value={formData.description}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    />

                    <DialogActions>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button type="submit" variant="contained" disabled={loading}>
                            {loading ? "Creating..." : "Create Machine"}
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
};

const EditMachineModal = ({ open, onClose, onSubmit, initialData }) => {
    const [formData, setFormData] = useState(initialData);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setFormData(initialData);
        }
    }, [open, initialData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        onSubmit(formData)
            .then(() => {
                onClose();
            })
            .catch(() => { })
            .finally(() => setLoading(false));
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Edit Machine</DialogTitle>
            <DialogContent>
                <DialogContentText mb={3}>
                    Update the details of the machine.
                </DialogContentText>

                <form onSubmit={handleSubmit}>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Name"
                        fullWidth
                        required
                        value={formData?.name || ""}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                    <TextField
                        margin="dense"
                        label="Serial Number"
                        fullWidth
                        required
                        value={formData?.serial_no || ""}
                        onChange={(e) => setFormData({ ...formData, serial_no: e.target.value })}
                    />
                    <TextField
                        margin="dense"
                        label="Description"
                        fullWidth
                        multiline
                        rows={2}
                        value={formData?.description || ""}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    />

                    <DialogActions>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button type="submit" variant="contained" disabled={loading}>
                            {loading ? "Updating..." : "Update Machine"}
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
};

const DeleteMachineModal = ({ open, onClose, onSubmit, machine }) => {

    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        onSubmit(machine?.id)
            .then(() => {
                onClose();
            })
            .catch(() => { })
            .finally(() => setLoading(false));
    };


    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Delete Machine</DialogTitle>
            <DialogContent>
                <DialogContentText mb={3}>
                    Are you sure you want to delete this machine?
                </DialogContentText>

                <form onSubmit={handleSubmit}>
                    <DialogActions>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button type="submit" variant="contained" color="error" disabled={loading}>
                            {loading ? "Deleting..." : "Delete Machine"}
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
};

const RestoreMachineModal = ({ open, onClose, onSubmit, machine }) => {

    const [loading, setLoading] = useState(false);
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(machine?.id)
            .then(() => {
                onClose();
            })
            .catch(() => { })
            .finally(() => setLoading(false));
    };


    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Restore Machine</DialogTitle>
            <DialogContent>
                <DialogContentText mb={3}>
                    Are you sure you want to restore this machine?
                </DialogContentText>

                <form onSubmit={handleSubmit}>
                    <DialogActions>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button type="submit" variant="contained" color="success" disabled={loading}>
                            {loading ? "Restoring..." : "Restore Machine"}
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
};

const ViewAuditLogsModal = ({ open, onClose, auditLogs }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Audit Logs</DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left">User</TableCell>
                <TableCell align="left">Action</TableCell>
                <TableCell align="left">Timestamp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {auditLogs.length > 0 ? (
                auditLogs.map((log) => (
                  <TableRow key={log._id}>
                    <TableCell align="left">{`${log.action_by} - ${log.action_by_type}`}</TableCell>
                    <TableCell align="left">{log.action}</TableCell>
                    <TableCell align="left">
                      {new Date(log.timestamp).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No audit logs available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
const ApMachine = ({ auths, machineList, setPage, page, setLimit, limit, total_results, fetchMachineList, metadata, loading }) => {
    const [viewPermission, setViewPermission] = useState(false);
    const [editPermission, setEditPermission] = useState(false);
    const [csvPermission, setCsvPermission] = useState(false);
    const { company_id } = useParams();
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [selectedMachine, setSelectedMachine] = useState(null);
    const navigate = useNavigate();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState({
        type: "",
        message: "",
    });
    const [openRestoreModal, setOpenRestoreModal] = useState(false);
    const [openViewAuditLogsModal, setOpenViewAuditLogsModal] = useState(false);
    const [auditLogs, setAuditLogs] = useState([]);
    useEffect(() => {
        const authData = JSON.parse(localStorage.getItem("AuthData"));
        if (auths?.user?.role?.permissions?.includes("view_machine") || authData?.type === "super_admin") {
            setViewPermission(true);
        }
        if (
            ["update_ap_machine"].every(k =>
                auths?.user?.role?.permissions?.includes(k)
            ) || authData?.type === "super_admin"
        ) {
            setEditPermission(true);
        }
        if (auths?.user?.role?.permissions?.includes("download_csv") || authData?.type === "super_admin") {
            setCsvPermission(true);
        }
    }, [auths]);

    const handleCreate = async (formData) => {
        try {
            const authData = JSON.parse(localStorage.getItem("AuthData"));
            const config = {
                headers: {
                    Authorization: "Bearer " + authData.access_token,
                },
            };
            const { data } = await axios.post(
                `/api/v1/${authData?.type}/machine`,
                formData,
                config
            );
            if (data.success) {
                setOpenCreateModal(false);
                setSnackbarMessage({
                    type: "success",
                    message: "Machine created successfully!",
                });
                setSnackbarOpen(true);
                fetchMachineList();
            }
        } catch (error) {
            console.error("Error creating machine:", error);
            setSnackbarMessage({
                type: "error",
                message: error?.response?.data?.error || error?.response?.statusText || "Error creating machine!",
            });
            setSnackbarOpen(true);
        }
    };

    const handleEdit = async (formData) => {
        formData.ap_company = company_id;
        try {
            const authData = JSON.parse(localStorage.getItem("AuthData"));
            const config = {
                headers: {
                    Authorization: "Bearer " + authData.access_token,
                },
            };
            const { data } = await axios.put(
                `/api/v1/${authData?.type}/machine/${formData.id}`,
                formData,
                config
            );
            if (data.success) {
                setOpenEditModal(false);
                setSnackbarMessage({
                    type: "success",
                    message: "Machine updated successfully!",
                });
                setSnackbarOpen(true);
                fetchMachineList();
            }
        } catch (error) {
            console.error("Error updating machine:", error);
            setSnackbarMessage({
                type: "error",
                message: error?.response?.data?.error || error?.response?.statusText || "Error updating machine!",
            });
            setSnackbarOpen(true);
        }
    };

    const handleDelete = async (machine_id) => {
        try {
            const authData = JSON.parse(localStorage.getItem("AuthData"));
            const config = {
                headers: {
                    Authorization: "Bearer " + authData.access_token,
                },
            };
            const { data } = await axios.delete(
                `/api/v1/${authData?.type}/machine/${machine_id}`,
                config
            );
            if (data.success) {
                setOpenDeleteModal(false);
                setSnackbarMessage({
                    type: "success",
                    message: "Machine deleted successfully!",
                });
                setSnackbarOpen(true);
                fetchMachineList();
            }
        } catch (error) {
            console.error("Error deleting machine:", error);
            setSnackbarMessage({
                type: "error",
                message: error?.response?.data?.error || error?.response?.statusText || "Error deleting machine!",
            });
            setSnackbarOpen(true);
        }
    };

    const handleRestore = async (machine_id) => {
        try {
            const authData = JSON.parse(localStorage.getItem("AuthData"));
            const config = {
                headers: {
                    Authorization: "Bearer " + authData.access_token,
                },
            };
            const { data } = await axios.put(
                `/api/v1/${authData?.type}/machine/${machine_id}/restore`,
                null,
                config
            );
            if (data.success) {
                setOpenRestoreModal(false);
                setSnackbarMessage({
                    type: "success",
                    message: "Machine restored successfully!",
                });
                setSnackbarOpen(true);
                fetchMachineList();
            }
        } catch (error) {
            console.error("Error restoring machine:", error);
            setSnackbarMessage({
                type: "error",
                message: error?.response?.data?.error || error?.response?.statusText || "Error restoring machine!",
            });
            setSnackbarOpen(true);
        }
    };

    const handleDeleteClick = (machine) => {
        setSelectedMachine(machine);
        setOpenDeleteModal(true);
    };

    const handleEditClick = (machine) => {
        setSelectedMachine(machine);
        setOpenEditModal(true);
    };

    const handleRestoreClick = (machine) => {
        setSelectedMachine(machine);
        setOpenRestoreModal(true);
    }

    return (
        <React.Fragment>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarMessage.type} sx={{ width: "100%" }}>
                    {snackbarMessage.message}
                </Alert>
            </Snackbar>

            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <EnhancedTable
                        machineList={machineList}
                        page={page}
                        setPage={setPage}
                        limit={limit}
                        setLimit={setLimit}
                        total_results={total_results}
                        viewPermission={viewPermission}
                        editPermission={editPermission}
                        csvPermission={csvPermission}
                        onCreateMachineOpen={() => setOpenCreateModal(true)}
                        onEditMachineOpen={handleEditClick}
                        auths={auths}
                        onDeleteMachineOpen={handleDeleteClick}
                        onRestoreMachineOpen={handleRestoreClick}
                        metadata={metadata}
                        loading={loading}
                        openViewAuditLogsModal={openViewAuditLogsModal}
                        setOpenViewAuditLogsModal={setOpenViewAuditLogsModal}
                        auditLogs={auditLogs}
                        setAuditLogs={setAuditLogs}
                    />
                    <CreateMachineModal
                        open={openCreateModal}
                        onClose={() => setOpenCreateModal(false)}
                        onSubmit={handleCreate}
                        company_id={company_id}
                    />
                    <EditMachineModal
                        open={openEditModal}
                        onClose={() => setOpenEditModal(false)}
                        onSubmit={handleEdit}
                        initialData={selectedMachine}
                    />
                    <DeleteMachineModal
                        open={openDeleteModal}
                        onClose={() => setOpenDeleteModal(false)}
                        onSubmit={handleDelete}
                        machine={selectedMachine}
                    />
                    <RestoreMachineModal
                        open={openRestoreModal}
                        onClose={() => setOpenRestoreModal(false)}
                        onSubmit={handleRestore}
                        machine={selectedMachine}
                    />
                    <ViewAuditLogsModal
                        open={openViewAuditLogsModal}
                        onClose={() => setOpenViewAuditLogsModal(false)}
                        auditLogs={auditLogs}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default ApMachine;